import ArticleSocialShare from '../components/ArticleSocialShare'
import MagazineCover from '../components/MagazineCover'
import { Search } from 'ion-icon'
import { Mobile, MobileElse, DesktopTablet } from 'ion-media'
import { ImageOrNoImage } from 'ion-image'
import NoImage from '../static/no-image.png'

export const ArticlePageSkeleton = () => (
  <div className='wrapper'>
    <div className='article-page'>
      <article role='contentinfo' aria-label='article' className='skeleton'>
        <h1 className='title' />
        <p className='meta' style={{ marginRight: '20%' }}>&nbsp;</p>
        <p className='meta' style={{ marginRight: '60%' }}>&nbsp;</p>
        <ArticleSocialShare className='inline-share-buttons' />
        <div itemProp='articleBody' className='article-body'>
          <div className='figure' width={640} height={480}>&nbsp;</div>
          <div className='articleBodyMore' id='article-more-body'>
            <p>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
            </p>
            <p>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
            </p>
            <p>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
            </p>
            <p>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
            </p>
          </div>
        </div>
      </article>
      <SidebarSkeleton>
        <MagazineCover />
      </SidebarSkeleton>
    </div>
  </div>
)

export const SidebarSkeleton = (props) => (
  <aside className='sidebar'>
    <div className='sidebar-search'>
      <form action='/search' method='get'>
        <input type='search' placeholder='Search Glamour' name='q' id='q' />
        <button>
          <Search width='18' height='18' />
        </button>
      </form>
    </div>
    {props.children}
    <Mobile>
      <div className='on-sale-now' />
    </Mobile>
    <div className='newsletter-subscribe'>
      <h5>Glamour NEWSLETTER</h5>
      <>
        <form name='item-form' id='item-form'>
          <input type='text' name='firstName' placeholder='First Name' id='firstName' required />
          <input type='text' name='lastName' placeholder='Last Name' id='lastName' />
          <input type='email' name='email' placeholder='Email Address' id='email' required />
          <button type='submit'>Subscribe</button>
        </form>
      </>
    </div>
    <div className='sidebar-articles'>
      {/* <MostReadArticles className='side-articles' noImage={NoImage} /> */}
    </div>
  </aside>
)

export const DefaultSectionPageSkeleton = (props) => {
  return (
    <>
      <div className='wrapper article-listing'>
        <div className='article-list'>
          <DefaultTemplateSkeleton />
        </div>
      </div>
      <SidebarSkeleton>
        <DesktopTablet>
          <MagazineCover />
        </DesktopTablet>
      </SidebarSkeleton>
    </>
  )
}

export const DefaultTemplateSkeleton = (props) => {
  return (
    <>
      <div className='skeleton'>
        <h1>{props.sectionLabel}</h1>
      </div>
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
    </>
  )
}

export const ArticleCardSkeleton = (props) => {
  return (
    <article className='skeleton'>
      <div className='article-list-img'>
        <Mobile>
          <ImageOrNoImage shape='square' width={450} noImage={NoImage} />
        </Mobile>
        <MobileElse>
          <ImageOrNoImage shape='square' width={670} noImage={NoImage} />
        </MobileElse>
      </div>
      <div className='content'>
        {/* Section label */}
        <div className='label' />
        {/* Article title */}
        <div className='title' />
        <div className='title title-short' />
      </div>
    </article>
  )
}
